export default {
  'welcome-user': 'Welcome You',
  tips: {
    login: 'Login',
    register: 'Register',
  },
  'login-title': 'Log in to your account',
  'login-or': 'or',
  'login-no-account': 'Don’t have an account?',
  'login-register': 'Sign Up',
  'login-success': 'Login successful',
  'login-failed': 'Login failed',
  'forget-password': 'Forgot Password?',
  login: 'Log In',
  email: 'Email',
  'phone-number': 'Phone Number',
  'email-address': 'Email Address',
  password: 'Password',
  'input-password': 'Input password',
  'reset-password': 'Reset Password',
  'verify-account': 'Verify your account for secure operations',
  'email-verification-code': 'Verification Code',
  'login-with-google': 'Google',
  'login-with-apple': 'Apple',
  // Added for login hero and passkey
  'client-portal': 'CLIENT PORTAL',
  'hero-line-1': 'GLOBALLY TRUSTED &',
  'hero-line-2': 'MULTI REGULATED BROKER',
  please: 'Please',
  'login-with-passkey': 'Passkey',
  settings: {
    'user-profile': {
      'send-code': 'Send Code',
    },
  },
  errors: {
    'email-required': 'Please enter your email',
    'email-invalid': 'Invalid email format',
    'phone-required': 'Please enter your phone number',
    'invalid-credentials': 'Invalid email or password',
    'unknown-error': 'An unexpected error occurred',
    emailLoginError: 'Please enter your email and password',
    phoneLoginError: 'Please enter your phone number and password',
  },
  countries: {
    US: 'United States',
    CN: 'China',
    JP: 'Japan',
    GB: 'United Kingdom',
    DE: 'Germany',
  },
  register: {
    welcome: 'Welcome to Register',
    'register-title': 'Please fill in the information below to create your account',
    thirdRegisAccount: 'Create New Account',
    thirdBindAccount: 'Bind Existing Account',
    form: {
      'personal-account': 'Personal Account',
      'corporate-account': 'Corporate Account',
      lastname: 'Last Name',
      firstname: 'First Name',
      'company-name': 'Company Name',
      'country-personal': 'Residence Country',
      'country-corporate': 'Country of Company Registration',
      phone: 'Phone Number',
      'email-verification-code': 'Verification Code',
      'invitation-code': 'Invitation Code',
      email: 'Email Address',
      password: 'Password',
      'confirm-password': 'Confirm Password',
      'agree-terms': 'Please agree to the Terms of Service and Privacy Policy',
      submit: 'Register',
      'send-verification-code': 'Send Verification Code',
      'select-country': 'Please select a country',
      'email-invalid': 'Please enter a valid email address',
      'password-required': 'Please enter a password',
      'confirm-password-required': 'Please confirm your password',
      'lastname-required': 'Please enter your last name',
      'name-empty': 'Please enter your name',
      'name-pattern':
        "Only letters, spaces, ( ) . - ' ·; no leading/trailing or consecutive punctuation/spaces (1-70 characters)",
      'company-name-pattern':
        "Company name may include letters, numbers, spaces, ( ) . - ' · and & / ,; no leading/trailing or consecutive punctuation/spaces (1-120 characters)",
      'lastname-pattern': "Last name: only letters, spaces, ( ) . - '",
      'firstname-required': 'Please enter your first name',
      'firstname-pattern': "First name: only letters, spaces, ( ) . - '",
      'code-required': 'Please enter the verification code',
      'company-name-required': 'Please enter the company name',
      'register-success': 'Registration Successful',
      'go-to-login': 'Go to Login',
      'link-line': 'or {0}',
      'customer-agreement': 'Customer Agreement',
      disclaimer:
        'By clicking "Submit", I confirm that I have read, understood and agree to the {0}. I agree that GTCFX may contact me within a reasonable time and that my phone number is not listed on the Do Not Call Register (DNCR). I declare that I am not a Politically Exposed Person (PEP) and have never held any significant public office. I further confirm that I have never been convicted of any offence related to money laundering, fraud, bribery, corruption or any other criminal offence, and that I am not currently subject to any ongoing regulatory or legal proceedings.',
      message: {
        success: 'Bind Success',
        'bind-email-error': 'The email cannot be the same as the third-party authorized email',
      },
      button: {
        submit: 'Confirm Bind',
      },
    },
  },
  resetPassword: {
    modal: {
      title: 'Reset Password',
      description: 'Verify your account for secure operations',
      encryptTip: 'All data is encrypted for security',
      form: {
        email: {
          label: 'Email',
          placeholder: 'Please enter your email',
          rule: {
            required: 'Please enter your email',
            invalid: 'Invalid email format',
          },
        },
        emailCode: {
          label: 'Email Verification Code',
          rule: {
            required: 'Please enter your email verification code',
          },
        },
        password: {
          label: 'Password',
          placeholder: 'Please enter your password',
          rule: {
            required: 'Please enter your password',
          },
        },
        button: {
          cancel: 'Cancel',
          ok: 'Confirm Change',
        },
      },
    },
  },
}
